export const buildProvenance = { "commitHash": "3ec2b8aeb36e1556873a7ebbc6bb976b54660e06", "branchName": "refs/heads/release/2024.4", "buildDate": "2024-12-15T16:07:59.975Z", "version": "2024.4.6995" };
